module.exports = __webpack_public_path__ + "img/ascending1.e1402ce8.svg";